import queryString from 'query-string';

import type { Filters, SortFilter, GroupFilter } from '../../models';

const parseSortFilter = (string_: string | string[]): SortFilter => {
  const sortFilter = Array.isArray(string_) ? string_.at(-1) : string_;
  switch (sortFilter) {
    case 'date-asc':
    case 'date-desc':
      return sortFilter as SortFilter;
    case 'smart':
      return 'date-desc';
    default:
      throw new Error('Unhandled sort filter');
  }
};

const parseGroupFilter = (string_: string | string[]): GroupFilter => {
  const groupFilter = Array.isArray(string_) ? string_.at(-1) : string_;
  switch (string_) {
    case 'expenseType':
    case 'supplier':
    case 'receiptStatus':
      return groupFilter as GroupFilter;
    default:
      throw new Error('Unhandled group option');
  }
};

const parseSearch = (string_: string | string[]): string => {
  return Array.isArray(string_) ? string_[0] || '' : string_;
};

export const urlQueryStringToFilters = (
  initialFilters: Filters,
  urlQueryString: string,
  // eslint-disable-next-line sonarjs/cognitive-complexity
): Filters => {
  const filters = { ...initialFilters };

  const queryParams = queryString.parse(urlQueryString, {
    arrayFormat: 'index',
  });

  if (queryParams.sort) {
    filters.sort = parseSortFilter(queryParams.sort);
  }

  if (queryParams.group) {
    filters.group = parseGroupFilter(queryParams.group);
  }

  if (queryParams.search) {
    filters.search = parseSearch(queryParams.search);
  }

  return filters;
};
